/**
 * Baby Registry Modal Web Component
 * Seamless integration for Milirose, MesEnvies, WhatsApp, SMS, Mail & Web Share API
 */

(function () {
  function getProductInfo() {
    // Title
    const titleEl = document.querySelector('.product__title h1, .product-3d__title, h1.product__title, h1');
    const title = titleEl ? titleEl.textContent.trim() : document.title;

    // Price
    const priceEl = document.querySelector('.price__regular .price-item--regular, .product-3d__price-main, .price-item');
    const price = priceEl ? priceEl.textContent.trim() : '';

    // Color or Variant option
    const colorEl = document.querySelector('[data-selected-color-name], fieldset input[type="radio"]:checked + label, .product-form__input input[type="radio"]:checked + label');
    const color = colorEl ? colorEl.textContent.trim() : '';

    // Variant ID & URL
    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    const variantId = variantInput ? variantInput.value : '';

    let currentUrl = window.location.href.split('?')[0];
    if (variantId) {
      currentUrl += `?variant=${variantId}`;
    }

    // Product Image
    const activeImg = document.querySelector('.product-3d__gallery-main img, .product__media-item.is-active img, .product__media-list li:first-child img, .product__media img, img[data-product-image]');
    const imgSrc = activeImg ? activeImg.getAttribute('src') : '';

    return { title, price, color, url: currentUrl, image: imgSrc };
  }

  class BabyRegistryModal extends HTMLElement {
    constructor() {
      super();
      this.isInitialized = false;
    }

    connectedCallback() {
      this.initDOM();
    }

    initDOM() {
      this.modal = this.querySelector('.registry-modal');
      this.closeBtn = this.querySelector('.registry-modal__close');
      this.backdrop = this.querySelector('.registry-modal__backdrop');
      this.copyBtn = this.querySelector('.registry-modal__copy-btn');
      this.copyInput = this.querySelector('.registry-modal__copy-input');
      this.toast = this.querySelector('.registry-modal__toast');
      this.platformCards = this.querySelectorAll('[data-platform]');
      this.shareCard = this.querySelector('[data-action="native-share"]');

      this.previewTitle = this.querySelector('.registry-modal__preview-title');
      this.previewVariant = this.querySelector('.registry-modal__preview-variant');
      this.previewPrice = this.querySelector('.registry-modal__preview-price');
      this.previewImg = this.querySelector('.registry-modal__preview-img');

      if (!this.isInitialized) {
        this.bindEvents();
        this.isInitialized = true;
      }
    }

    bindEvents() {
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      }

      if (this.backdrop) {
        this.backdrop.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });

      if (this.copyBtn) {
        this.copyBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.copyCurrentLink();
        });
      }

      if (this.platformCards) {
        this.platformCards.forEach((card) => {
          card.addEventListener('click', (e) => {
            e.preventDefault();
            const platform = card.dataset.platform;
            this.handlePlatformClick(platform);
          });
        });
      }

      if (this.shareCard) {
        this.shareCard.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleNativeShare();
        });
      }
    }

    isOpen() {
      if (!this.modal) this.initDOM();
      return this.modal && this.modal.classList.contains('is-active');
    }

    open() {
      this.initDOM();
      this.updateProductDetails();
      if (this.modal) {
        this.modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    }

    close() {
      if (!this.modal) this.initDOM();
      if (this.modal) {
        this.modal.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    }

    updateProductDetails() {
      const data = getProductInfo();
      if (this.previewTitle && data.title) this.previewTitle.textContent = data.title;
      if (this.previewPrice && data.price) this.previewPrice.textContent = data.price;
      if (this.previewVariant) {
        this.previewVariant.textContent = data.color ? `Option sélectionnée : ${data.color}` : '';
        this.previewVariant.style.display = data.color ? 'block' : 'none';
      }
      if (this.previewImg && data.image) {
        this.previewImg.src = data.image;
        this.previewImg.style.display = 'block';
      }
      if (this.copyInput && data.url) {
        this.copyInput.value = data.url;
      }
    }

    copyCurrentLink() {
      const url = this.copyInput ? this.copyInput.value : window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.triggerCopySuccess();
        }).catch(() => {
          this.fallbackCopy(url);
        });
      } else {
        this.fallbackCopy(url);
      }
    }

    fallbackCopy(text) {
      if (this.copyInput) {
        this.copyInput.select();
        document.execCommand('copy');
        this.triggerCopySuccess();
      }
    }

    triggerCopySuccess() {
      if (this.copyBtn) {
        const originalText = this.copyBtn.innerHTML;
        this.copyBtn.classList.add('is-copied');
        this.copyBtn.innerHTML = '<span>✓</span> Copié !';
        setTimeout(() => {
          this.copyBtn.classList.remove('is-copied');
          this.copyBtn.innerHTML = originalText;
        }, 2200);
      }
      this.showToast('Lien du produit copié dans le presse-papier !');
    }

    showToast(message) {
      if (!this.toast) return;
      this.toast.textContent = message;
      this.toast.classList.add('is-visible');
      setTimeout(() => {
        this.toast.classList.remove('is-visible');
      }, 3000);
    }

    handlePlatformClick(platform) {
      this.copyCurrentLink();

      let targetUrl = '';
      let platformName = '';

      switch (platform) {
        case 'milirose':
          platformName = 'Milirose';
          targetUrl = 'https://www.milirose.com/';
          break;
        case 'mesenvies':
          platformName = 'MesEnvies.fr';
          targetUrl = 'https://www.mesenvies.fr/';
          break;
        default:
          targetUrl = 'https://www.milirose.com/';
      }

      this.showToast(`Lien copié ! Ouverture de ${platformName}...`);

      setTimeout(() => {
        window.open(targetUrl, '_blank', 'noopener,noreferrer');
      }, 300);
    }

    handleNativeShare() {
      const data = getProductInfo();
      if (navigator.share) {
        navigator.share({
          title: data.title,
          text: `Découvre ce produit pour la liste de naissance : ${data.title} ${data.color ? '(' + data.color + ')' : ''}`,
          url: data.url
        }).catch((err) => {
          console.log('Share canceled or not supported', err);
        });
      } else {
        this.copyCurrentLink();
        this.showToast('Lien copié pour le partage (WhatsApp / SMS / Mail) !');
      }
    }
  }

  if (!customElements.get('baby-registry-modal')) {
    customElements.define('baby-registry-modal', BabyRegistryModal);
  }

  // Global document click handler for [data-open-baby-registry]
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-open-baby-registry]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    const customEl = document.querySelector('baby-registry-modal');
    if (customEl && typeof customEl.open === 'function') {
      customEl.open();
      return;
    }

    // Direct fallback if custom element hasn't upgraded yet
    const modal = document.querySelector('.registry-modal');
    if (modal) {
      const data = getProductInfo();
      const title = modal.querySelector('.registry-modal__preview-title');
      if (title && data.title) title.textContent = data.title;
      const price = modal.querySelector('.registry-modal__preview-price');
      if (price && data.price) price.textContent = data.price;
      const copyInput = modal.querySelector('.registry-modal__copy-input');
      if (copyInput && data.url) copyInput.value = data.url;
      const img = modal.querySelector('.registry-modal__preview-img');
      if (img && data.image) {
        img.src = data.image;
        img.style.display = 'block';
      }
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
  });
})();
